export const isSameTrain =
  (existingTrain, outboundDate, trainNumbers) =>
  ({ legs }) => {
    const newTrainNumbers = legs.map((leg) => leg.trainNumber);

    return existingTrain && existingTrain?.date === outboundDate && trainNumbers.every((number) => newTrainNumbers.includes(number));
  };
